import React, { memo } from 'react'
import VideoGroupItem from '../VideoGroupItem'
import { IVideoDropdownModel, IVideoModelGroup } from '../types'
import * as Styled from './styled'

interface ISectionedModelListProps {
  groups: IVideoModelGroup[]
  selectedKey: string | null
  onSelect: (model: IVideoDropdownModel) => void
  getGroupLabels: (group: IVideoModelGroup) => string[]
  onInnerSlideUpOpenChange?: (open: boolean) => void
}

const SectionedModelList: React.FC<ISectionedModelListProps> = ({
  groups,
  selectedKey,
  onSelect,
  getGroupLabels,
  onInnerSlideUpOpenChange
}) => (
  <Styled.DropdownListWrapper>
    {groups.map(group => (
      <VideoGroupItem
        key={group.key}
        group={group}
        selectedKey={selectedKey}
        onSelect={onSelect}
        labels={getGroupLabels(group)}
        onMobileExpandChange={onInnerSlideUpOpenChange}
      />
    ))}
  </Styled.DropdownListWrapper>
)

export default memo(SectionedModelList)
